import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "notInDingTalk",
      component: () => import("@/views/notInDingTalk")
    },
    {
      path: "/center-login",
      name: "登录页",
      component: () => import(/* webpackChunkName: "page" */ "@/views/Login"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/energy_tab",
      name: "能耗监测",
      component: () => import("@/views/energy_monitor/energy_tab"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/energy_data",
      name: "能耗数据",
      component: () => import("@/views/energy_monitor/energy_data"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/pv_data",
      name: "光伏",
      component: () => import("@/views/pv_data/index"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/investment_manage",
      name: "招商管理",
      component: () => import("@/views/investment_manage/index"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/small_investment_manage",
      name: "小屏手机招商管理",
      component: () => import("@/views/investment_manage/small_screen_index"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/investment_search",
      name: "investment_search",
      component: () => import("@/views/investment_manage/investment_search"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/investment_detail",
      name: "investment_detail",
      component: () => import("@/views/investment_manage/investment_detail"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/investment_add/:loc",
      name: "investment_add",
      component: () => import("@/views/investment_manage/investment_add")
      // meta: {
      //   keepAlive: true,
      //   isTab: false,
      //   isAuth: false,
      // }
    },
    {
      path: "/select_address_loc",
      name: "选择地理位置",
      component: () => import("@/views/investment_manage/SelectAddressLoc")
    },
    {
      path: "/house_view",
      name: "在线看房",
      component: () => import("@/views/house_view/house_view"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/house_detail/:id",
      name: "house_detail",
      component: () => import("@/views/house_view/house_detail"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },

    {
      path: "/incident_list",
      name: "物业报事",
      component: () =>
        import(
          /* webpackChunkName: "page" */ "@/views/incident_view/incident_list"
        ),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/incident_add",
      name: "新增报事",
      component: () =>
        import(
          /* webpackChunkName: "page" */ "@/views/incident_view/incident_add"
        ),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/carbon_manager",
      name: "碳运营",
      component: () =>
        import(
          /* webpackChunkName: "page" */ "@/views/carbon_view/carbon_manager"
        ),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/address_select",
      name: "选择位置",
      component: () => import("@/views/incident_view/address_select")
    },
    {
      path: "/resubmit_order",
      name: "重新提交",
      component: () => import("@/views/incident_view/resubmit_order"),
      meta: {
        keepAlive: true,
        title: ""
      }
    },
    {
      path: "/check-detail/:id/:isList?",
      name: "检查管理详情",
      component: () => import("@/views/check-management/check-detail")
      // meta: {
      //   keepAlive: true,
      //   title: ''
      // }
    },
    {
      path: "/check-handle/:taskId/:flowId/:actionType/:orderList",
      name: "履约检查",
      component: () => import("@/views/check-management/check-handle")
      // meta: {
      //   keepAlive: true,
      //   title: ''
      // }
    },
    {
      path: "/reform_list",
      name: "创建整改单",
      component: () => import("@/views/check-management/reform_list")
      // meta: {
      //   keepAlive: true,
      //   title: ''
      // }
    },
    {
      path: "/person-list/:taskId/:flowId/:actionType/:tranUser?",
      name: "选择人员",
      component: () => import("@/views/check-management/person-list")
      // meta: {
      //   keepAlive: true,
      //   title: ''
      // }
    },
    {
      path: "/handle-page/:taskId/:flowId/:actionType/:tranUser?",
      name: "处理工单",
      component: () => import("@/views/check-management/handle-page")
      // meta: {
      //   keepAlive: true,
      //   title: ''
      // }
    },
    {
      path: "/incident_order_detail/:id/:isOwner/:isCheck?",
      name: "工单详情",
      component: () => import("@/views/incident_manage/incident_order_detail"),
      meta: {
        keepAlive: true,
        title: ""
      }
    },
    {
      path: "/rectified_order/:id/:isOwner/:isCheck?",
      name: "整改单单详情",
      component: () => import("@/views/incident_manage/rectified_order")
    },
    {
      path: "/incident_handle/:matterId/:flowId/:actionType/:totalResignation?",
      name: "处理工单",
      component: () => import("@/views/incident_manage/handle_page")
    },
    {
      path: "/replay_handle/:matterId/:flowId/:actionType",
      name: "转派工单",
      component: () => import("@/views/incident_manage/replay_handle"),
      meta: {
        keepAlive: true,
        title: ""
      }
    },
    {
      path: "/select_person_list/:matterId/:flowId",
      name: "选择人员列表",
      component: () => import("@/views/incident_manage/select_person_list")
    },
    {
      path: "/select_person/:matterId/:flowId/:memberType",
      name: "选择人员",
      component: () => import("@/views/incident_manage/select_person")
    },
    {
      path: "/evaluate_input/:matterId/:actionType/:isShowBack/:isDetail?",
      name: "评价",
      component: () => import("@/views/incident_manage/evaluate_input")
      // meta: {
      //   keepAlive: true,
      //   title: ''
      // }
    },
    {
      path: "/resubmit_service",
      name: "业主重新服务",
      component: () => import("@/views/incident_manage/resubmit_service")
    },
    {
      path: "/incident_success",
      name: "重新服务提交成功",
      component: () => import("@/views/incident_manage/incident_success")
    },

    {
      path: "/goods_grant_list",
      name: "goods_grant_list",
      component: () => import("@/views/goods_grant/list/index"),
      meta: {
        keepAlive: true,
        title: ""
      }
    },
    {
      path: "/goods_grant_search",
      name: "goods_grant_search",
      component: () => import("@/views/goods_grant/search/index"),
      meta: {
        keepAlive: true,
        title: "搜索"
      }
    },
    {
      path: "/goods_grant_detail/:id",
      name: "goods_grant_detail",
      component: () => import("@/views/goods_grant/detail/index"),
      meta: {
        keepAlive: false,
        title: "详情"
      }
    },
    {
      path: "/goods_grant_add",
      name: "goods_grant_add",
      component: () => import("@/views/goods_grant/add/index"),
      meta: {
        keepAlive: true,
        title: "物品放行"
      }
    },
    {
      path: "/goods_grant_select_room",
      name: "goods_grant_select_room",
      component: () => import("@/views/goods_grant/add/select_room"),
      meta: {
        keepAlive: false,
        title: "选择房间"
      }
    },
    {
      path: "/goods_grant_add_success",
      name: "goods_grant_add_success",
      component: () => import("@/views/goods_grant/add/success"),
      meta: {
        keepAlive: false,
        title: "提交成功"
      }
    },
    {
      path: "/question_answer/:isShowHeader/:projectId", // :isShowHeader是否显示标题,projectId项目id
      name: "问卷调查",
      component: () => import("@/views/question/QuestionAnswer")
    },
    {
      path: "/question_answer_detail/:key/:projectId/:projectName",
      name: "问卷调查详情",
      component: () => import("@/views/question/QuestionAnswerDetail")
    },
    {
      path: "/question_answer_result",
      name: "问卷调查反馈",
      component: () => import("@/views/question/QuestionAnswerResult")
    },
    {
      path: "/campus_activities/:isShowHeader/:projectId", // projectId项目id
      name: "园区活动",
      component: () => import("@/views/campus/CampusActivities"),
      meta: {
        title: "园区活动"
      }
    },

    {
      path: "/campus_activities_detail/:activityId/:isShowHeader",
      name: "园区活动详情",
      component: () => import("@/views/campus/CampusActivitiesDetail")
    },

    {
      path: "/campus_activities_sign_up/:projectId/:activityId/:isShowHeader",
      name: "园区活动报名",
      component: () => import("@/views/campus/CampusActivitiesSignUp"),
      meta: {
        keepAlive: true,
        isBack: false,
        title: "报名"
      }
    },

    {
      path: "/campus_activities_sign_up_addr/:projectId/:isShowHeader",
      name: "切换房屋",
      component: () => import("@/views/campus/CampusActivitiesSignUpAddr"),
      meta: {
        title: "选择位置"
      }
    },

    {
      path:
        "/campus_activities_sign_up_result/:projectId/:activityId/:isShowHeader",
      name: "园区活动报名反馈",
      component: () => import("@/views/campus/CampusActivitiesSignUpResult"),
      meta: {
        title: "报名成功"
      }
    },
    {
      path:
        "/campus_activities_my_sign_up/:projectId/:activityId/:isShowHeader",
      name: "我的报名",
      component: () => import("@/views/campus/CampusActivitiesMySignUp"),
      meta: {
        title: "我的报名"
      }
    },
    {
      path: "/campus_activities_scan/:isShowHeader",
      name: "活动扫码",
      component: () => import("@/views/campus/CampusActivitiesScan"),
      meta: {
        title: "扫描二维码"
      }
    },
    {
      path: "/campus_activities_scan_wx/:isShowHeader",
      name: "活动扫码微信",
      component: () => import("@/views/campus/CampusActivitiesScanWx"),
      meta: {
        title: "扫描二维码"
      }
    },
    {
      path: "/campus_activities_scan_result/:isShowHeader",
      name: "扫码失败",
      component: () => import("@/views/campus/CampusActivitiesScanResult"),
      meta: {
        title: "识别失败"
      }
    },
    {
      path: "/campus_activities_comments",
      name: "园区活动评论",
      component: () =>
        import("@/views/campus/comments/CampusActivitiesComments")
    },

    {
      path: "/campus_activities_comments_detail/:projectId/:activityId/:model",
      name: "园区活动评论详情",
      component: () =>
        import("@/views/campus/comments/CampusActivitiesCommentsDetail"),
      meta: {
        title: "全部评论"
      }
    },
    {
      path: "/charging_pile_index/:projectId",
      name: "充电桩",
      component: () => import("@/views/charging_pile/charging_pile_index")
    },
    {
      path: "/wechart_moments_index",
      name: "园区论坛",
      component: () => import("@/views/wechart_moments/wechart_moments_index")
    },
    {
      path: "/edit_wechart_moments",
      name: "发布新动态",
      component: () => import("@/views/wechart_moments/edit_wechart_moments")
    },
    {
      path: "/wechart_moments_details",
      name: "动态详情",
      component: () => import("@/views/wechart_moments/wechart_moments_details")
    },
    {
      path: "/wechart_moments_comment",
      name: "评论",
      component: () => import("@/views/wechart_moments/wechart_moments_comment")
    },
    {
      path: "/visitor_invitation_record",
      name: "访客预约",
      component: () => import("@/views/visitor/list/visitor_invitation_record"),
      meta: {
        title: ""
      }
    },
    {
      path: "/visitor_invitation_record_zjwy",
      name: "访客预约",
      component: () =>
        import("@/views/visitor/list/visitor_invitation_record_zjwy"),
      meta: {
        title: ""
      }
    },
    {
      path: "/visitor_invitation_search",
      name: "访客搜索",
      component: () => import("@/views/visitor/list/visitor_invitation_search"),
      meta: {
        title: "搜索"
      }
    },
    {
      path: "/addInvitationPersonInformation/:visitor_registration",
      name: "新增邀请人员信息",
      component: () =>
        import("@/views/visitor/new/AddInvitationPersonInformation"),
      meta: {
        keepAlive: true,
        title: "新增邀请"
      }
    },
    {
      path: "/IntervieweeList",
      name: "选择被访人",
      component: () => import("@/views/visitor/new/IntervieweeList"),
      meta: {
        title: "选择被访人"
      }
    },
    {
      path: "/addInvitationControlInformation/:visitor_registration",
      name: "新增邀请更多信息",
      component: () =>
        import("@/views/visitor/new/AddInvitationControlInformation"),
      meta: {
        title: "新增邀请",
        keepAlive: true
      }
    },
    {
      path: "/AddFollower",
      name: "添加跟随人员",
      component: () => import("@/views/visitor/new/AddFollower")
      // meta: {
      //   title: '新增邀请'
      // }
    },
    {
      path: "/visitor_invitation_detail/:id",
      name: "访客预约详情",
      component: () => import("@/views/visitor/detail/VisitorInvitationDetail"),
      meta: {
        title: "预约详情",
        keepAlive: true
      }
    },
    {
      path: "/visitor_detail_select_door",
      name: "访客预约详情选择门禁",
      component: () => import("@/views/visitor/detail/VisitorDetailSelectDoor")
    },
    {
      path: "/visitor_invitation_detail_approve",
      name: "访客预约详情审批意见",
      component: () =>
        import("@/views/visitor/detail/VisitorInvitationDetailApprove")
    },
    {
      path: "/visitor_invitation_detail_approve_page",
      name: "访客预约详情审批意见",
      component: () =>
        import("@/views/visitor/detail/VisitorInvitationDetailApprovePage")
    },
    {
      path: "/info/:id",
      name: "访客登记已邀约",
      component: () => import("@/views/visitor/registration/Info")
    },
    {
      path: "/visitor_detail_qrcode",
      name: "访客二维码",
      component: () => import("@/views/visitor/detail/VisitorDetailQrcode.vue")
    },
    {
      path: "/visitor_share_add_success",
      name: "访客登记成功",
      component: () => import("@/views/visitor/new/Finish.vue")
    },
    {
      path: "/info_zjwy/:id",
      name: "访客登记已邀约",
      component: () => import("@/views/visitor/registration/info_zjwy")
    },
    {
      path: "/visit_new",
      name: "新增",
      component: () => import("@/views/visitor/new/new_list"),
      meta: {
        keepAlive: true
      }
    },
    {
      path:
        "/select_door_other/:permissionType/:productId/:isThree/:status_height",
      name: "选择门禁(非兴海平台）",
      component: () => import("@/views/visitor/new/select_door_other"),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/select_door/:permissionType/:productId/:status_height/:ids?",
      name: "选择门禁",
      component: () => import("@/views/visitor/new/select_door"),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/select_door_search/:permissionType/:productId",
      name: "选择门禁搜索",
      component: () => import("@/views/visitor/new/select_door_search")
    },
    {
      path: "/apply_area_permissions",
      name: "区域权限申请",
      component: () =>
        import("@/views/area_permissions/apply_area_permissions"),
      meta: {
        title: "区域权限申请"
      }
    },
    {
      path: "/area_permissions_record",
      name: "区域权限申请记录",
      component: () =>
        import("@/views/area_permissions/area_permissions_record"),
      meta: {
        title: "区域权限申请记录"
      }
    },
    {
      path: "/remote_open_door",
      name: "远程开门",
      component: () => import("@/views/open_door/remote_open_door")
    },
    {
      path: "/face_entry_start",
      name: "face_entry_start",
      component: () => import("@/views/face_entry/face_entry_start")
    },
    {
      path: "/face_entry",
      name: "face_entry",
      component: () => import("@/views/face_entry/face_entry")
    },
    {
      path: "/face_entry_end",
      name: "face_entry_end",
      component: () => import("@/views/face_entry/face_entry_end")
    },
    {
      path: "/face_entry_detail",
      name: "face_entry_detail",
      component: () => import("@/views/face_entry/face_entry_detail")
    },
    {
      path: "/face_entry_check",
      name: "face_entry_check",
      component: () => import("@/views/face_entry/face_entry_check")
    },
    {
      path: "/face_entry_cropping",
      name: "face_entry_check",
      component: () => import("@/views/face_entry/face_entry_cropping")
    },
    {
      path: "/punch_clock_face_entry",
      name: "punch_clock_face_entry",
      component: () => import("@/views/face_entry/punch_clock_face_entry")
    },
    {
      path: "/punch_clock_face_start",
      name: "punch_clock_face_start",
      component: () => import("@/views/face_entry/punch_clock_face_start")
    },
    {
      path: "/punch_clock_face_finished",
      name: "punch_clock_face_finished",
      component: () => import("@/views/face_entry/punch_clock_face_finished")
    },
    {
      path: "/guess_data/:status_height?",
      name: "客流分析",
      component: () => import("@/views/guess_data/index"),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/home",
      name: "Home",
      component: () => import(/* webpackChunkName: "page" */ "@/views/Home"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: true
      },
      children: [
        {
          path: "/house_view_list",
          name: "在线看房1",
          component: () => import("@/views/house_view/house_view"),
          meta: {
            keepAlive: true,
            isTab: false,
            isAuth: true
          }
        }
      ]
    },
    {
      path: "/fitment_list_home",
      name: "fitment_list_home",
      component: () => import("@/views/fitment/list/index_list"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false,
        title: "装修申请"
      }
    },
    {
      path: "/fitment_apply_detail/:id",
      name: "fitment_apply_detail",
      component: () => import("@/views/fitment/list/fitment_apply_detail"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false,
        title: "申请单详情"
      }
    },
    {
      path: "/fitment_add",
      name: "fitment_add",
      component: () => import("@/views/fitment/add/index/index"),
      meta: {
        keepAlive: true,
        title: "填写申请表"
      }
    },
    {
      path: "/file_show",
      name: "附件预览",
      component: () => import("@/views/fitment/add/FileShow"),
      meta: {
        title: "附件预览"
      }
    },
    {
      path: "/pdf_preview",
      name: "pdf附件预览",
      component: () => import("@/components/PdfPreview"),
      meta: {
        title: "pdf附件预览"
      }
    },
    {
      path: "/word_preview",
      name: "word附件预览",
      component: () => import("@/components/WordPreview"),
      meta: {
        title: "word附件预览"
      }
    },
    {
      path: "/xlsx_preview",
      name: "xlsx附件预览",
      component: () => import("@/components/XlsxPreview"),
      meta: {
        title: "xlsx附件预览"
      }
    },
    {
      path: "/un_support_preview",
      name: "不支持此类附件预览",
      component: () => import("@/views/fitment/UnSupportPreview"),
      meta: {
        title: "不支持此类附件预览"
      }
    },
    {
      path: "/fitment_add_success",
      name: "fitment_add_success",
      component: () => import("@/views/fitment/add/success"),
      meta: {
        keepAlive: false,
        title: "提交成功"
      }
    },
    {
      path: "/order_tab",
      name: "工单统计",
      component: () => import("@/views/order_statistics/order_tab"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/order_setting",
      name: "工单统计设置",
      component: () => import("@/views/order_statistics/order_setting"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/people_efficiency_list",
      name: "人员效率统计",
      component: () =>
        import("@/views/order_statistics/people_efficiency_list"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/people_comment_list",
      name: "人员评价平均分统计",
      component: () => import("@/views/order_statistics/people_comment_list"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/long_open_door",
      name: "long_open_door",
      component: () => import("@/views/visitor/longOpen/index.vue"),
      meta: {
        keepAlive: true,
        title: ""
      }
    },
    {
      path: "/customer_visit_list",
      name: "大客户到访记录",
      component: () => import("@/views/customer/index.vue"),
      meta: {
        keepAlive: true,
        title: "大客户到访记录"
      }
    },
    {
      path: "/customer_visit_detail",
      name: "大客户到访记录详情",
      component: () => import("@/views/customer/Detail.vue"),
      meta: {
        keepAlive: false,
        title: "大客户到访记录详情"
      }
    },
    {
      path: "/hkPlayer",
      name: "hk视频",
      component: () => import("@/views/hkPlayer/index.vue"),
      meta: {
        keepAlive: false,
        title: "hk视频"
      }
    },
    {
      path: "/check_list",
      name: "检查管理列表",
      component: () => import("@/views/check-management/check_list"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    //物业评价
    {
      path: "/property_evalution_view",
      name: "property_evalution_view",
      component: () =>
        import("@/views/property_evalution/propertyEvalutionView"),
      meta: {
        keepAlive: false,
        title: "物业评价"
      }
    },
    //物业评价首页
    {
      path: "/property_view",
      name: "物业评价首页",
      component: () => import("@/views/property_evalution/propertyView"),
      meta: {
        keepAlive: true,
        isTab: false,
        isAuth: false
      }
    },
    //历史评价
    {
      path: "/property_history",
      name: "历史评价",
      component: () => import("@/views/property_evalution/propertyHistory"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },

    {
      path: "/rent_control",
      name: "租控图",
      component: () => import("@/views/rent_control/rent_control.vue"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/room_list",
      name: "房间列表",
      component: () => import("@/views/rent_control/room_list.vue"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/rent_search",
      name: "租控搜索",
      component: () => import("@/views/rent_control/rent_search.vue"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/rent_detail",
      name: "租控详情",
      component: () => import("@/views/rent_control/rent_detail.vue"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/smart_community",
      name: "智慧社区",
      component: () => import("@/views/smart_community/index.vue"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/project_select",
      name: "切换项目",
      component: () => import("@/views/smart_community/project_select.vue"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/forgetpw",
      name: "忘记密码",
      component: () => import("@/views/smart_community/forgetpw.vue"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/setPassWord",
      name: "设置密码",
      component: () => import("@/views/smart_community/setPassWord.vue"),
      meta: {
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/center_invitation", // 中建物业来访登记
      name: "center_invitation",
      component: () => import("@/views/visitor/zhongjian_invitation/index.vue"),
      meta: {
        title: "来访登记",
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },

    {
      path: "/center_success",
      name: "center_success",
      component: () =>
        import("@/views/visitor/zhongjian_invitation/success.vue"),
      meta: {
        keepAlive: false,
        title: "提交成功"
      }
    },

    {
      path: "/takePhotos",
      name: "takePhotos",
      component: () => import("@/views/face/takePhotos.vue"),
      meta: {
        title: "拍摄图像"
      }
    },
    {
      path: "/myHouse",
      name: "myHouse",
      component: () => import("@/views/smart_community/myHouse.vue"),
      meta: {
        title: "我的房屋"
      }
    },
    {
      path: "/customer-payment",
      name: "customer-payment",
      component: () => import("@/views/customer_payment/index.vue"),
      meta: {
        title: "代客缴费",
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/customer-payment-search",
      name: "customer-payment-search",
      component: () => import("@/views/customer_payment/search.vue"),
      meta: {
        title: "搜索",
        keepAlive: false,
        isTab: false,
        isAuth: false
      }
    },
    {
      path: "/customer-payment-success",
      name: "customer-payment-success",
      component: () => import("@/views/customer_payment/success.vue"),
      meta: {
        title: ""
      }
    },
    {
      path: "/visitorInvitation/:visitor_registration",
      name: "新增邀请人员信息",
      component: () => import("@/views/visitor/new/visitorInvitation"),
      meta: {
        keepAlive: true,
        title: "新增邀请"
      }
    },
    {
      path: "/visitor_invitation_detail_new/:id",
      name: "新访客预约详情",
      component: () =>
        import("@/views/visitor/detail/VisitorInvitationDetailNew")
    },
    {
      path: "/visitor", //clhk_copy
      name: "邀请方式",
      component: () => import("@/views/visitor/new/visitor.vue"),
      meta: {
        title: "邀请",
        keepAlive: false
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    // 异步滚动操作
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
  }
});

// // 能避免如蜜传如蜜导致错误
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }



// WEBPACK FOOTER //
// ./src/router/index.js